export type PhoneSpecs = {
  screen?: number
  chip?: string
  camera_mp?: number
  ram_gb?: number
  g5?: boolean
  foldable?: boolean
}

export type PhoneSpecRow = {
  id: 'chip' | 'screen' | 'ram' | 'camera' | 'fiveG' | 'foldable'
  value: string
}

export function parsePhoneSpecs(specsJson: string | null | undefined): PhoneSpecs | null {
  if (!specsJson?.trim()) return null
  try {
    const raw = JSON.parse(specsJson) as unknown
    if (!raw || typeof raw !== 'object') return null
    return raw as PhoneSpecs
  } catch {
    return null
  }
}

/** Build display rows from catalog specs_json (chip, RAM, screen, etc.). */
export function buildPhoneSpecRows(specs: PhoneSpecs | null): PhoneSpecRow[] {
  if (!specs) return []
  const rows: PhoneSpecRow[] = []
  if (specs.chip) rows.push({ id: 'chip', value: specs.chip })
  if (specs.screen != null && specs.screen > 0) {
    rows.push({ id: 'screen', value: `${specs.screen}"` })
  }
  if (specs.ram_gb != null && specs.ram_gb > 0) {
    rows.push({ id: 'ram', value: `${specs.ram_gb} GB` })
  }
  if (specs.camera_mp != null && specs.camera_mp > 0) {
    rows.push({ id: 'camera', value: `${specs.camera_mp} MP` })
  }
  if (specs.g5 === true) rows.push({ id: 'fiveG', value: '5G' })
  if (specs.foldable === true) rows.push({ id: 'foldable', value: 'Foldable' })
  return rows
}
